import React, { useState, useEffect } from "react";
import "./Article.css";

const Article =(props) =>{
  const [isMobile, setIsMobile] = useState(true);
  useEffect(()=>{
    if(window.innerWidth > 768){
      setIsMobile(false);
    }
  },[]);
  let items= props.items.map((item,index)=>{
    return <div className="article-child-wrapper col-11 col-md-8"  key={index} 
                    style={{backgroundImage: !!item.MashanTopMobileImage ? `url(${item.MashanTopMobileImage.ImageUrl})`: ''}} >
          {!!item.MashanTopDesktopImage && 
              <div className="container-article-img  col-12 col-md-6  d-none d-md-block" 
                    >
                        <div style={{backgroundImage:`url(${item.MashanTopDesktopImage.ImageUrl}?RenditionID=14`,backgroundSize: 'cover',minHeight:'555px'}}></div>
              </div>
              }
            <div className="article-title-text col-12 col-md-6">
                <div className="col-12 col-md-11">
                {item.ContainerTitle}
                {!!item.MashanTopDesktopImage && <div className="container-article-img  col-12 col-md-6 d-block d-md-none" 
                          >
                      <img src={item.MashanTopDesktopImage.ImageUrl+'?RenditionID=13'} />  
                    </div>}
                <div className="article-text" dangerouslySetInnerHTML={{__html:item.RichTextContainer}}></div>
                {!!item.MashanContainerLink &&
                <a className="article-link" href={item.MashanContainerLink.NavigateUrl} >{item.MashanContainerLink.Text}
                </a>}
             </div>
           </div>
        </div>
});
    return (
          <div className="container-article-wrapper row nav-section" id={`nav-section-0`} >
              {items}
          </div>
    )
}


export default Article;